import './HomeFoodInput.css'

export default function HomeFoodInput({onFilter, inputValue}) {
    return (
        <div className="home-food-input">
            <input type="text" placeholder='...' value={inputValue} onChange={(e) => onFilter && onFilter(e.target.value)}/>
        </div>
    )
}